const platformName = process.env.VUE_APP_PLATFORM || process.env.NUXT_ENV_PLATFORM
const App = require(`./${platformName}/`).default
const Platform = new App()

console.log(`Initializing ${platformName} platform!`)

// Init Initial required things
Platform.init()

export default Platform
